<template>
  <section class="project-details-area pt-120 pb-70">
    <div class="container">
      <!--<div class="row">
        <div class="col-xxl-12">
          <div class="project-big-thumb">
            <img
              src="../../assets/img/portfolio/portfolio-big-img.jpg"
              alt=""
            />
          </div>
        </div>
      </div>-->
      <div class="row">
        <div class="col-xxl-8 col-xl-8 col-lg-8 col-md-12">
          <div class="p-details-content mb-40">
            <h3>Offline capacities</h3>
            <p>
              The possibility for XClin to operate without an internet
              connection enable the collection of clinical data in the following
              settings:
            </p>
            <li>• Data Collection at patient home</li>
            <li>• Data Collection in very remote medical centers</li>
            <li>• Data Collection in very remote medical centers</li>
            <li>• Data Source Verification in hospital archive room</li>
            <li>• Data Collection in surgical room</li>
            <li>• Data Collection in crops plantation</li>
            <p></p>
            <p>
              Furthermore its offers many benefits from a usability point of
              view
            </p>

            <li>
              • Increased robustness against connection interruption (like when
              moving from one hospital room to the other)
            </li>
            <li>
              • Optimal user responsiveness even when the internet connection is
              sub-optimal
            </li>
            <li>
              • Possibility to work with large data element like Medical
              Imaging, Voice Recording, Sensor Data
            </li>
          </div>
        </div>
        <div class="col-xxl-4 col-xl-4 col-lg-4 col-md-6">
          <div class="platform-big-thumb">
            <img src="../../assets/img/platform/AfricaOffline.jpeg" alt="" />
          </div>
          <!--<div class="sidebar-wrap mb-40">
                           <div class="sidebar-right">
                              <div class="sidebar-single">
                                    <label>Clients:</label>
                                    <span>Jessica Brown</span>
                              </div>
                              <div class="sidebar-single">
                                    <label>Category:</label>
                                    <span>Design, Development</span>
                              </div>
                              <div class="sidebar-single">
                                    <label>Value:</label>
                                    <span>Jessica Brown</span>
                              </div>
                              <div class="sidebar-single">
                                    <label>Date:</label>
                                    <span>20 June, 2022</span>
                              </div>
                           </div>
                        </div>-->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "PlatformDetailsOffline",
};
</script>